<template>
  <v-container v-scroll="onScroll" class="pa-0 ma-auto">
    <div ref="articletop" class="top"></div>
    <infinite-loading
      v-if="topinfinit"
      direction="top"
      :identifier="infiniteId + 1000"
      @infinite="addArticlesToTopHandler"
      spinner="bubbles"
    >
      <div slot="error" slot-scope="{ trigger }">
        Ого, почему-то не загрузилась предыдущая статья. Ошибка:
        {{ errorLoadingData }}. Попробуйте
        <a
          href="javascript:;"
          @click="trigger"
        >загрузить</a> её еще раз.
      </div>
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>

    <div v-for="article in articlesList" :key="article.results[0].id">
      <ArticleComponent
        :article="article.results[0]"
        @enteringScreen="articleEnteringScreenHandler"
        @leavingScreen="articleLeavingScreenHandler"
        @headerEnteringScreen="articleHeaderEnteringScreenHandler"
        @headerLeavingScreen="articleHeaderLeavingScreenHandler"
      ></ArticleComponent>
    </div>

    <infinite-loading
      :identifier="infiniteId"
      @infinite="addArticlesToBottomHandler"
      spinner="bubbles"
    >
      <div slot="error" slot-scope="{ trigger }">
        Ого, почему-то не загрузилась следующая статья. Ошибка:
        {{ errorLoadingData }}. Попробуйте
        <a
          href="javascript:;"
          @click="trigger"
        >загрузить</a> её еще раз.
      </div>
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </v-container>
</template>

<script>
import ArticleComponent from '@/components/ArticleComponent.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  props: {
    // Список артиклов, которые мы показываем.
    // Состоит из объектов полученных из API
    // НЕ очищеннных от сервисной информации пейджинга
    // поэтому сами объекты Article лежат в results
    // и забирать объекты Article надо из results[0]
    // а это значит, что у нас все работает ТОЛЬКО при количестве артилов на одной странице равной 1!
    articlesList: {
      type: Array,
      required: true
    },
    errorLoadingData: {
      type: String,
      default: ''
    }
  },

  components: {
    ArticleComponent,
    InfiniteLoading
  },
  data() {
    return {
      // нам не всегда надо показывать верхний infinite-loading компонент,
      // потому что когда мы показываем какой-то Артикл из середины списка,
      // то предыдущий мы не хотим срразу подгружать пока не начали скролить вверх
      // инача страница дергается
      // ниже описана довольно замысловатая логика
      topinfinit: false,

      // поскольку нам периодически нужно перегружать infinite-loading,
      // например когда мы прыгаем из верхнего меню,
      // то нам нужен какой-то идентификатор для него.
      // когда мы будем менять значение идентификатора, то infinite-loading будет перегружаться
      infiniteId: new Date(),

      // нужены для определения направления скролирования
      scrollPos: -1,
      scrollDirection: ''
    }
  },
  computed: {
    numberOfArticles() {
      return this.articlesList.length
    }
  },

  watch: {
    // общий смысл работы с infinite-loading таков,
    // что изначально мы запускаем компонент с пустым списком артиклов articlesList
    // срабатывает нижний лоадер и подгружает один или несколько артиклов через addArticlesToBottomHandler
    // поэтому когда приходит пустой список это значит, что нам надо отрефрешить infinite-loading
    // (он мог уже получить статус complete и тогда он не будет больше смотреть новые артиклы)
    articlesList: function(newVal) {
      if (newVal.length == 0) {
        this.infiniteId += 1 // Это очень странное на первый взгляд действие заставляяет отрефрешиться InfinitList
        this.topinfinit = false // не нужен нам пока верхний infinite-loading
      }
    }
  },

  updated() {
    // чот я хз правильно ли это написано (немного смущает что numberOfArticles строго равняется 1)
    // идея такая, что при загрузке первого артикла ставить его аккуртно к верху страницы
    // потому что скролинг браузера может находиться в бог знает какой позиции и артикл покажется например с середины
    if (this.numberOfArticles == 1) {
      this.$vuetify.goTo(this.$refs.articletop, { offset: 78, duration: 0 })
    }
  },

  methods: {
    onScroll(e) {
      let newScrollPos = e.target.body.getBoundingClientRect().top

      // Топ инфинит у нас может показываться всегда, кроме момента перехода на новую статью по меню
      // поэтому мы ее не показываем когда у нас в список статей добавляется самая первая статья
      // а начинаем мы ее показывать когда у нас уже есть хотя бы одна статья
      // и пользователь доскроллировал до 0 (до самого верха)
      if (newScrollPos == 0 && this.numberOfArticles > 0) {
        this.topinfinit = true
      }
      //console.log('NEW SCROLL', newScrollPos)
      if (this.scrollPos > newScrollPos) {
        this.scrollDirection = 'DOWN'
      } else {
        this.scrollDirection = 'UP'
      }

      this.scrollPos = newScrollPos
    },

    // Скролл ВНИЗ + Исчезание заголовка артикла -> Артикл становится текущим
    // (Уехала за экран плашка с хедером артикла и надо показать название артикла в плашке путешествия)
    articleHeaderLeavingScreenHandler(article) {
      if (this.scrollDirection == 'DOWN') {
        console.log('CALL CURRENT ARTICLE CHANGE', 'header leaving', 'down')
        this.$emit('currentArticleChange', article)
      }
    },
    // Скролл ВНИЗ + Исчезание артикла -> Текущий артикл = NULL
    // (Уехал за экран артикл и не надо больше показывать его названние в плашке путешествия)

    // eslint-disable-next-line no-unused-vars
    articleLeavingScreenHandler(article) {
      if (this.scrollDirection == 'DOWN') {
        this.$emit('currentArticleChange', null)
      }
    },

    // Скролл ВВЕРХ + Появленине артикла -> Артикл становится текущим
    // (На экране появился низ артикла и надо егго название показать в плашке пуутешествия)
    articleEnteringScreenHandler(article) {
      // тут есть логическая проблемка, которую пока не решили. когда при выборе из мееню появляется самый первый артикл,
      // то хендлер срабатываеет, а писать назввание артикла бы пока не надо

      if (this.scrollDirection == 'UP') {
        console.log('CALL CURRENT ARTICLE CHANGE', 'article entering', 'up')
        this.$emit('currentArticleChange', article)
      }
    },

    // Скролл ВВЕРХ + Появление заголовка артикла -> Текущий артикл = NULL
    // (На экране появился низ заголовка артиклаизначит не надо больше показывать его названние в плашке путешествия)

    // eslint-disable-next-line no-unused-vars
    articleHeaderEnteringScreenHandler(article) {
      if (this.scrollDirection == 'UP') {
        this.$emit('currentArticleChange', null)
      }
    },

    addArticlesToBottomHandler($state) {
      if (this.numberOfArticles == 0) {
        // Список артиклов еще пустой, а значит это мы добавляем самый первый артикл
        // В этот момент нам НЕ нужно показывать топ инфинит, потому что иначе у нас сразу загррузится предыдущая статья
        // А вот когда нам нужно показать топинфиннит смотрите в onScroll

        this.topinfinit = false
      }
      console.log('EMIT addArticlesToBottom')
      this.$emit('addArticlesToBottom', $state)
    },
    addArticlesToTopHandler($state) {
      this.$emit('addArticlesToTop', $state)
    }
  }
}
</script>

<style></style>
